import request from '@/utils/request'

function QUERY({ key, params }) {
  let url
  // 获取通讯录的标签
  if (key == 'GetAddressBook') {
    url = '/h5/MailList/GetQueryData'
  }

  // 获取用户信息设置的标签
  if (key == 'GetSetLabel') {
    url = '/h5/CustomerInfo/getSetLabel'
  }

  // 删除自定义标签
  if (key == 'delCustomLabel') {
    url = '/h5/CustomerInfo/delCustomLabel'
  }

  // 保存自定义标签
  if (key == 'addCustomLabel') {
    url = '/h5/CustomerInfo/addCustomLabel'
  }

  // 保存自定义客户标签
  if (key == 'customerMarking') {
    url = '/h5/CustomerInfo/customerMarking'
  }

  // 获取通讯录的列表
  if (key == 'getTableData') {
    url = '/h5/MailList/getTableData'
  }
  
  if (typeof params == 'object') {
    params['version'] = 'MINI'
  } else {
    params = { version: 'MINI' }
  }
  return request({
    url,
    method: 'post',
    params
  })
}

export default QUERY;